<!-- 我的课程 -->
<template>
  <div class="el-MyAppsCenter" :class="{ 'is-backColor': on_show !== 1 }">
    <div class="el-MyAppsHander">
      <el-button
        :type="on_show == 1 ? 'primary' : 'plain'"
        class="mb20"
        @click="MyAppsHandover(1)"
        >数字金融</el-button
      >
      <el-button
        :type="on_show == 2 ? 'primary' : 'plain'"
        class="mb20"
        @click="MyAppsHandover(2)"
        >数字经济</el-button
      >
    </div>
    <el-row class="content_block mb30 p10" v-if="on_show !== 2">
      <el-row class="upper_part_wrap">
        <div class="upper_part">
          <div class="heading">
            <h5 style="color: #ffffff">国内外宏观经济运行与金融监管平台</h5>
          </div>
          <ul>
            <li>
              <div class="agency">
                <img src="../../images/apps/01.png" />
                <a
                  @click="myAppsDetails('中央银行、财政部、其他政府机构')"
                  :class="
                    'layui-btn' + disabledInfo('中央银行、财政部、其他政府机构')
                  "
                  >中央银行、财政部、其他政府机构</a
                >
              </div>
              <div class="function">
                <img src="../../images/apps/icon_arrow_down01.png" />
                <p>货币政策 财政政策</p>
              </div>
            </li>
            <li>
              <div class="agency">
                <img src="../../images/apps/02.png" />
                <a
                  @click="myAppsDetails('证监会、银保监会、行业协会')"
                  :class="
                    'layui-btn' + disabledInfo('证监会、银保监会、行业协会')
                  "
                  >证监会、银保监会、行业协会</a
                >
              </div>
              <div class="function">
                <img src="../../images/apps/icon_arrow_down01.png" />
                <p>监管/自律/牌照</p>
              </div>
            </li>
            <li>
              <div class="agency">
                <img src="../../images/apps/03.png" />

                <a
                  @click="myAppsDetails('国外经济、国外政局')"
                  :class="'layui-btn' + disabledInfo('国外经济、国外政局')"
                  >国外经济、国外政局</a
                >
              </div>
              <div class="function">
                <img src="../../images/apps/icon_arrow_down01.png" />
                <p>关联影响</p>
              </div>
            </li>
          </ul>
        </div>
      </el-row>
      <div class="middle_part_wrap">
        <div class="middle_part">
          <div class="left">
            <p>资金供给</p>
          </div>
          <ul class="center">
            <li>
              <div class="headline_wrap">
                <div class="headline">
                  <img src="../../images/apps/application_icon_03.png" />
                  <h6>金融产品设计</h6>
                </div>
              </div>
              <div class="product">
                <a
                  @click="myAppsDetails('风险管理')"
                  :class="'layui-btn' + disabledInfo('风险管理')"
                  ><img src="../../images/apps/04.png" /><span
                    >风险管理</span
                  ></a
                >
                <a
                  @click="myAppsDetails('期权建模')"
                  :class="'layui-btn' + disabledInfo('期权建模')"
                  ><img src="../../images/apps/05.png" /><span
                    >期权建模</span
                  ></a
                >
                <a
                  @click="myAppsDetails('仿真预测')"
                  :class="'layui-btn' + disabledInfo('仿真预测')"
                  ><img src="../../images/apps/06.png" /><span
                    >仿真预测</span
                  ></a
                >
                <a
                  @click="myAppsDetails('征信评级')"
                  :class="'layui-btn' + disabledInfo('征信评级')"
                  ><img src="../../images/apps/07.png" /><span
                    >征信评级</span
                  ></a
                >
                <a
                  @click="myAppsDetails('估值定价')"
                  :class="'layui-btn' + disabledInfo('估值定价')"
                  ><img src="../../images/apps/08.png" /><span
                    >估值定价</span
                  ></a
                >
                <a
                  @click="myAppsDetails('资产证券化')"
                  :class="'layui-btn' + disabledInfo('资产证券化')"
                  ><img src="../../images/apps/09.png" /><span
                    >资产证券化</span
                  ></a
                >
              </div>
            </li>
            <img
              src="../../images/apps/application_arrow_02.png"
              class="arrow"
            />
            <li>
              <div class="headline_wrap">
                <div class="headline">
                  <img src="../../images/apps/application_icon_04.png" />
                  <h6>金融产品发行市场</h6>
                </div>
              </div>
              <div class="product">
                <a
                  @click="myAppsDetails('承销/挂牌')"
                  :class="'layui-btn' + disabledInfo('承销/挂牌')"
                  ><img src="../../images/apps/10.png" /><span
                    >承销/挂牌</span
                  ></a
                >
                <a
                  @click="myAppsDetails('并购重组')"
                  :class="'layui-btn' + disabledInfo('并购重组')"
                  ><img src="../../images/apps/11.png" /><span
                    >并购重组</span
                  ></a
                >
                <a
                  @click="myAppsDetails('私募')"
                  :class="'layui-btn' + disabledInfo('私募')"
                  ><img src="../../images/apps/12.png" /><span>私募</span></a
                >
                <a
                  @click="myAppsDetails('投资银行')"
                  :class="'layui-btn' + disabledInfo('投资银行')"
                  ><img src="../../images/apps/13.png" /><span
                    >投资银行</span
                  ></a
                >
              </div>
            </li>
            <img
              class="arrow"
              src="../../images/apps/application_arrow_02.png"
            />
            <li>
              <div class="headline_wrap">
                <div class="headline">
                  <img src="../../images/apps/application_icon_05.png" />
                  <h6>金融产品流通市场</h6>
                </div>
              </div>
              <div class="product">
                <a
                  @click="myAppsDetails('证券交易')"
                  :class="'layui-btn' + disabledInfo('证券交易')"
                  ><img src="../../images/apps/14.png" /><span
                    >证券交易</span
                  ></a
                >
                <a
                  @click="myAppsDetails('融资融券')"
                  :class="'layui-btn' + disabledInfo('融资融券')"
                  ><img src="../../images/apps/15.png" /><span
                    >融资融券</span
                  ></a
                >
                <a
                  @click="myAppsDetails('数据资讯')"
                  :class="'layui-btn' + disabledInfo('数据资讯')"
                  ><img src="../../images/apps/16.png" /><span
                    >数据资讯</span
                  ></a
                >
                <a
                  @click="myAppsDetails('研究咨询')"
                  :class="'layui-btn' + disabledInfo('研究咨询')"
                  ><img src="../../images/apps/17.png" /><span
                    >研究咨询</span
                  ></a
                >
                <a
                  @click="myAppsDetails('登记结算')"
                  :class="'layui-btn' + disabledInfo('登记结算')"
                  ><img src="../../images/apps/18.png" /><span
                    >登记结算</span
                  ></a
                >
                <a
                  @click="myAppsDetails('智能理财')"
                  :class="'layui-btn' + disabledInfo('智能理财')"
                  ><img src="../../images/apps/19.png" /><span
                    >智能理财</span
                  ></a
                >
              </div>
            </li>
            <li class="last">
              <div class="headline_wrap">
                <div class="headline">
                  <img src="../../images/apps/20.png" />
                  <h6>金融市场参与主体</h6>
                </div>
              </div>
              <div class="product">
                <a href="#" class="conter-text">
                  <a
                    @click="myAppsDetails('证券/期货/基金/信托/资管公司')"
                    :class="
                      'layui-btn' + disabledInfo('证券/期货/基金/信托/资管公司')
                    "
                    ><img src="../../images/apps/21.png" /><span
                      >证券/期货/基金</span
                    ></a
                  >
                  <a
                    @click="myAppsDetails('外汇')"
                    :class="'layui-btn' + disabledInfo('外汇')"
                    ><img src="../../images/apps/61.png" /><span>外汇</span></a
                  >
                </a>
                <a
                  @click="myAppsDetails('商业银行/政策性银行/信用合作社机构')"
                  :class="
                    'layui-btn' +
                    disabledInfo('商业银行/政策性银行/信用合作社机构')
                  "
                  ><img src="../../images/apps/22.png" /><span
                    >商业银行/政策性银行/信用合作社机构</span
                  ></a
                >
                <a
                  @click="myAppsDetails('保险公司')"
                  :class="'layui-btn' + disabledInfo('保险公司')"
                  ><img src="../../images/apps/23.png" /><span
                    >保险公司</span
                  ></a
                >
                <a
                  @click="myAppsDetails('经纪/做市商')"
                  :class="'layui-btn' + disabledInfo('经纪/做市商')"
                  ><img src="../../images/apps/53.png" /><span
                    >经纪/做市商</span
                  ></a
                >
                <a
                  @click="myAppsDetails('P2P网络借贷公司')"
                  :class="'layui-btn' + disabledInfo('P2P网络借贷公司')"
                  ><img src="../../images/apps/24.png" /><span
                    >P2P网络借贷公司</span
                  ></a
                >
                <a
                  @click="myAppsDetails('众筹公司')"
                  :class="'layui-btn' + disabledInfo('众筹公司')"
                  ><img src="../../images/apps/25.png" /><span
                    >众筹公司</span
                  ></a
                >
                <a
                  @click="myAppsDetails('第三方支付公司')"
                  :class="'layui-btn' + disabledInfo('第三方支付公司')"
                  ><img src="../../images/apps/26.png" /><span
                    >第三方支付公司</span
                  ></a
                >
                <a
                  @click="myAppsDetails('征信评级机构')"
                  :class="'layui-btn' + disabledInfo('征信评级机构')"
                  ><img src="../../images/apps/27.png" /><span
                    >征信评级机构</span
                  ></a
                >
                <a
                  @click="myAppsDetails('供应链金融服务公司')"
                  :class="'layui-btn' + disabledInfo('供应链金融服务公司')"
                  ><img src="../../images/apps/28.png" /><span
                    >供应链金融服务公司</span
                  ></a
                >
                <a
                  @click="myAppsDetails('金融科技服务公司')"
                  :class="'layui-btn' + disabledInfo('金融科技服务公司')"
                  ><img src="../../images/apps/29.png" /><span
                    >金融科技服务公司</span
                  ></a
                >
              </div>
            </li>
          </ul>
          <div class="left">
            <p>资金需求</p>
          </div>
        </div>
      </div>
      <div class="bottom_part_wrap">
        <div class="bottom_part">
          <div class="head">
            <div class="arrow_up">
              <img src="../../images/apps/application_arrow_03.png" />
            </div>
            <div class="heading">
              <h5>金融发展技术基石</h5>
            </div>
            <div class="arrow_up">
              <img src="../../images/apps/application_arrow_03.png" />
            </div>
          </div>
          <ul class="technology">
            <li>
              <div class="headline_wrap">
                <div class="title">
                  <img src="../../images/apps/30.png" />
                  <h6>大数据技术</h6>
                </div>
              </div>
              <div class="technology_item">
                <a
                  @click="myAppsDetails('可视化BI')"
                  :class="'layui-btn' + disabledInfo('可视化BI')"
                  ><img src="../../images/apps/31.png" /><span
                    >可视化BI</span
                  ></a
                >
                <a
                  @click="myAppsDetails('金融大数据')"
                  :class="'layui-btn' + disabledInfo('金融大数据')"
                  ><img src="../../images/apps/62.png" /><span
                    >金融大数据</span
                  ></a
                >
                <a
                  @click="myAppsDetails('分析挖掘')"
                  :class="'layui-btn' + disabledInfo('分析挖掘')"
                  ><img src="../../images/apps/63.png" /><span
                    >分析挖掘</span
                  ></a
                >
                <a
                  @click="myAppsDetails('商务大数据')"
                  :class="'layui-btn' + disabledInfo('商务大数据')"
                  ><img src="../../images/apps/indicatorsxq-new.png" /><span
                    >商务大数据</span
                  ></a
                >
                <a
                  @click="myAppsDetails('大数据ETL')"
                  :class="'layui-btn' + disabledInfo('大数据ETL')"
                  ><img src="../../images/apps/64.png" /><span
                    >大数据ETL</span
                  ></a
                >
                <a
                  @click="myAppsDetails('用户画像')"
                  :class="'layui-btn' + disabledInfo('用户画像')"
                  ><img src="../../images/apps/65.png" /><span
                    >用户画像</span
                  ></a
                >
                <a
                  @click="myAppsDetails('大数据基础')"
                  :class="'layui-btn' + disabledInfo('大数据基础')"
                  ><img src="../../images/apps/33.png" /><span
                    >大数据基础</span
                  ></a
                >
                <a
                  @click="myAppsDetails('文本挖掘')"
                  :class="'layui-btn' + disabledInfo('文本挖掘')"
                  ><img src="../../images/apps/34.png" /><span
                    >文本挖掘</span
                  ></a
                >
              </div>
            </li>
            <li>
              <div class="headline_wrap">
                <div class="title">
                  <img src="../../images/apps/35.png" />
                  <h6>人工智能技术</h6>
                </div>
              </div>

              <div class="technology_item">
                <a
                  @click="myAppsDetails('智能风控')"
                  :class="'layui-btn' + disabledInfo('智能风控')"
                  ><img src="../../images/apps/36.png" /><span
                    >智能风控</span
                  ></a
                >
                <a
                  @click="myAppsDetails('智能投顾')"
                  :class="'layui-btn' + disabledInfo('智能投顾')"
                  ><img src="../../images/apps/37.png" /><span
                    >智能投顾</span
                  ></a
                >
                <a
                  @click="myAppsDetails('AIGC大模型')"
                  :class="'layui-btn' + disabledInfo('AIGC大模型')"
                  ><img src="../../images/apps/38.png" /><span
                    >AIGC大模型</span
                  ></a
                >
                <a
                  @click="myAppsDetails('数字贸易')"
                  :class="'layui-btn' + disabledInfo('数字贸易')"
                  ><img src="../../images/apps/39.png" /><span
                    >数字贸易</span
                  ></a
                >
                <a
                  @click="myAppsDetails('数字营销')"
                  :class="'layui-btn' + disabledInfo('数字营销')"
                  ><img src="../../images/apps/40.png" /><span
                    >数字营销</span
                  ></a
                >
                <a
                  @click="myAppsDetails('智能交易')"
                  :class="'layui-btn' + disabledInfo('智能交易')"
                  ><img src="../../images/apps/41.png" /><span
                    >智能交易</span
                  ></a
                >
                <a
                  @click="myAppsDetails('AI基础')"
                  :class="'layui-btn' + disabledInfo('AI基础')"
                  ><img src="../../images/apps/42.png" /><span>AI基础</span></a
                >
                <a
                  @click="myAppsDetails('机器学习')"
                  :class="'layui-btn' + disabledInfo('机器学习')"
                  ><img src="../../images/apps/66.png" /><span
                    >机器学习</span
                  ></a
                >
              </div>
            </li>
            <li>
              <div class="headline_wrap">
                <div class="title">
                  <img src="../../images/apps/44.png" />
                  <h6>云计算技术</h6>
                </div>
              </div>
              <div class="technology_item">
                <a
                  @click="myAppsDetails('公有云')"
                  :class="'layui-btn' + disabledInfo('公有云')"
                  ><img src="../../images/apps/45.png" /><span>公有云</span></a
                >
                <a
                  @click="myAppsDetails('私有云')"
                  :class="'layui-btn' + disabledInfo('私有云')"
                  ><img src="../../images/apps/46.png" /><span>私有云</span></a
                >
                <a
                  @click="myAppsDetails('容器服务')"
                  :class="'layui-btn' + disabledInfo('容器服务')"
                  ><img src="../../images/apps/47.png" /><span
                    >容器服务</span
                  ></a
                >
                <a
                  @click="myAppsDetails('金融 SaaS 应用')"
                  :class="'layui-btn' + disabledInfo('金融 SaaS 应用')"
                  ><img src="../../images/apps/48.png" /><span
                    >金融SaaS应用</span
                  ></a
                >
                <a
                  @click="myAppsDetails('云数据库')"
                  :class="'layui-btn' + disabledInfo('云数据库')"
                  ><img src="../../images/apps/49.png" /><span
                    >云数据库</span
                  ></a
                >
                <a
                  @click="myAppsDetails('云储存')"
                  :class="'layui-btn' + disabledInfo('云储存')"
                  ><img src="../../images/apps/50.png" /><span>云储存</span></a
                >
                <a
                  @click="myAppsDetails('云主机')"
                  :class="'layui-btn' + disabledInfo('云主机')"
                  ><img src="../../images/apps/51.png" /><span>云主机</span></a
                >
              </div>
            </li>
            <li>
              <div class="headline_wrap">
                <div class="title">
                  <img src="../../images/apps/52.png" />
                  <h6>区块链技术</h6>
                </div>
              </div>
              <div class="technology_item">
                <a
                  @click="myAppsDetails('支付清算')"
                  :class="'layui-btn' + disabledInfo('支付清算')"
                  ><img src="../../images/apps/53.png" /><span
                    >支付清算</span
                  ></a
                >
                <a
                  @click="myAppsDetails('......')"
                  :class="'layui-btn' + disabledInfo('......')"
                  ><img src="../../images/apps/54.png" /><span>......</span></a
                >
                <a
                  @click="myAppsDetails('数字票据')"
                  :class="'layui-btn' + disabledInfo('数字票据')"
                  ><img src="../../images/apps/55.png" /><span
                    >数字票据</span
                  ></a
                >
                <a
                  @click="myAppsDetails('数字供应链')"
                  :class="'layui-btn' + disabledInfo('数字供应链')"
                  ><img src="../../images/apps/56.png" /><span
                    >数字供应链</span
                  ></a
                >
                <a
                  @click="myAppsDetails('数字发票')"
                  :class="'layui-btn' + disabledInfo('数字发票')"
                  ><img src="../../images/apps/57.png" /><span
                    >数字发票</span
                  ></a
                >
                <a
                  @click="myAppsDetails('数字资产')"
                  :class="'layui-btn' + disabledInfo('数字资产')"
                  ><img src="../../images/apps/58.png" /><span
                    >数字资产</span
                  ></a
                >
                <a
                  @click="myAppsDetails('数字人民币')"
                  :class="'layui-btn' + disabledInfo('数字人民币')"
                  ><img src="../../images/apps/59.png" /><span
                    >数字人民币</span
                  ></a
                >
                <a
                  @click="myAppsDetails('区块链技术')"
                  :class="'layui-btn' + disabledInfo('区块链技术')"
                  ><img src="../../images/apps/60.png" /><span
                    >区块链技术</span
                  ></a
                >
              </div>
            </li>
          </ul>
        </div>
      </div>
    </el-row>
    <Economics v-if="on_show !== 1" />
  </div>
</template>

<script>
import RichText from "@/components/RichText/index";
import Economics from "./MyAppsEconomics.vue";
export default {
  name: "MyCourse",
  components: {
    RichText,
    Economics,
  },
  data() {
    return {
      myAppsList: [],
      appInfo: {},
      timeIn: null,
      on_show: 1,
    };
  },
  created() {},
  mounted() {
    this.getInfo();
    //this.addSystem();
  },
  methods: {
    disabledInfo(key) {
      if (this.$isEmpty(key)) {
        return " layui-btn-disabled";
      }
      if (!this.$isEmpty(this.appInfo[key]) && this.appInfo[key].canUsed) {
        return "";
      } else {
        return " layui-btn-disabled";
      }
    },
    getInfo() {
      let AppsList = [
        "证监会、银保监会、行业协会",
        "数字贸易",
        "大数据基础",
        "区块链技术",
        "可视化BI",
        "文本挖掘",
        "AI基础",
        "数字人民币",
        "数字供应链",
        "机器学习",
        "数字发票",
        "供应链金融",
        "数字营销",
        "金融大数据",
        "智能风控",
      ];
      let Appsitem = [];
      this.$post("/api/resourcesApplication/getPageList.do", {
        page: 1,
        limit: 10000,
      }).then((ret) => {
        if (ret.code == 0) {
          this.myAppsList = ret.data;
          for (let item of ret.data) {
            this.appInfo[item.applicationSecondLevelRelation] = item;
            if (AppsList.includes(item.applicationSecondLevelRelation)) {
              Appsitem.push(item);
            }
          }
          Appsitem.sort((a, b) => {
            return (
              AppsList.indexOf(a.applicationSecondLevelRelation) -
              AppsList.indexOf(b.applicationSecondLevelRelation)
            );
          });
          console.log(
            Appsitem.filter(
              (item) => item.applicationSecondLevelRelation == "数字贸易"
            ),
            "Appsitem"
          );
          this.$forceUpdate();
          sessionStorage.setItem("Appsitem", JSON.stringify(Appsitem));
        } else {
          this.$message({ message: ret.msg, type: "error" });
        }
      });
    },
    myAppsDetails(key) {
      //应用中心详情
      if (!this.$isEmpty(this.appInfo[key]) && this.appInfo[key].canUsed) {
        // if(key=='金融大数据'){
        this.$router.push({
          name: "MyAppsDetails2",
          query: { id: this.appInfo[key].resourcesApplicationId },
        });
        // }else{
        //     this.$router.push({name:'MyAppsDetails',query:{id:this.appInfo[key].resourcesApplicationId}});
        // }
      }
    },
    addSystem() {
      //模块使用统计
      //模块使用时间 开始
      const timeNum = this.$ls.get("timeNum"); //获取统一
      this.timeIn = setInterval(() => {
        let param = {
          firstName: "应用中心", //一级名称
          secondName: "应用中心", //二级名称
          useDuration: timeNum / 1000 / 60, //单次使用时长（单位：分钟）
        };
        this.$addSystemUseLog(param);
      }, timeNum);
      // 结束
    },
    MyAppsHandover(id) {
      this.on_show = id;
    },
  },
  beforeDestroy() {
    clearInterval(this.timeIn); //关闭定时
  },
};
</script>
 <style  lang="less">
.el-MyAppsCenter {
  background-color: #383f4a;
  padding: 20px 20px 0;
  .el-MyAppsHander {
    width: 1260px;
    // height: 100px;
    margin: 0 auto;
    color: #fff;
  }
  p {
    margin: 0;
  }
  a {
    text-decoration: none;
  }
  .content_block {
    width: 1260px;
    margin: 0 auto;
    background-color: #383f4a;
    .container {
      width: 1200px;
      margin: 100px auto 80px;
    }

    .heading {
      margin: 0 0 20px 0;
      text-align: center;
    }

    .heading h5 {
      height: 24px;
      line-height: 24px;
      font-size: 20px;
      color: #fff;
      background: url(../../images/apps/title_bg1.png) left center no-repeat,
        url(../../images/apps/title_bg2.png) right center no-repeat;
      padding: 0 40px;
      display: inline-block;
      margin: 0;
    }

    .heading h6 {
      height: 14px;
      line-height: 14px;
      color: #fff;
      font-size: 12px;
    }

    .upper_part_wrap,
    .bottom_part_wrap {
      width: 100%;
      background: repeating-linear-gradient(
        135deg,
        transparent,
        transparent 3px,
        #1585bc 3px,
        #1585bc 8px
      );
      animation: shine 1s infinite linear;
      overflow: hidden;
    }

    .middle_part_wrap {
      margin: 15px 0;
    }

    .middle_part_wrap {
      width: 100%;
      background: repeating-linear-gradient(
        135deg,
        transparent,
        transparent 3px,
        #152bbc 3px,
        #152bbc 8px
      );
      animation: shine 1s infinite linear;
      overflow: hidden;
    }
    .upper_part {
      /*width:100%;
      	border: dashed 2px #1585bc;*/
      padding: 10px 20px 5px;
      box-sizing: border-box;
      margin: 2px;
      background-color: #383f4a;
    }

    @keyframes shine {
      0% {
        background-position: -1px -1px;
      }

      100% {
        background-position: -12px -12px;
      }
    }

    .upper_part ul {
      display: flex;
      justify-content: space-between;
    }

    .upper_part ul li {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }

    .upper_part ul li .agency {
      width: 240px;
      height: 87px;
      /*line-height: 34px;*/
      /*border-radius: 5px;*/
      /*border: solid 1px #00a0e9;*/
      /*text-align: center;*/
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    .upper_part ul li .agency .layui-btn {
      width: 110px;
      height: auto;
      font-size: 12px;
      line-height: 22px;
      margin-left: 12px;
      background-color: transparent;
      white-space: pre-wrap;
      text-align: left;
      padding: 0;
      border: none;
    }

    .layui-btn {
      color: #4ef2fc;
      cursor: pointer;
    }
    .upper_part ul li .agency .layui-btn-disabled {
      color: #bbb;
      cursor: no-drop !important;
    }

    /*.upper_part ul li .agency p {
                      width:110px;
                      color: #e1e2e3;
                      font-size: 12px;
                      line-height:22px;
                      margin-left:12px;
                  }*/

    .upper_part ul li .function {
      height: 24px;
      line-height: 24px;
      font-size: 12px;
      color: #fff;
      display: flex;
      justify-content: flex-start;
      align-content: center;
    }

    .upper_part ul li .function img {
      margin-right: 6px;
    }
    .middle_part {
      /*width:1200px;*/
      /*height:572px;*/
      margin: 2px;
      padding: 10px 20px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      /*border: #152bbc 2px dashed;*/
      background-color: #383f4a;
    }

    .middle_part .left {
      width: 45px;
      height: auto;
      border: #ffdd75 1px solid;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .middle_part .left p {
      /*writing-mode: vertical-lr;*/
      font-size: 16px;
      color: #fff;
      font-weight: bold;
      margin: 0 20px;
    }

    .middle_part .center {
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      align-content: center;
      flex-wrap: wrap;
      margin: 0 20px;
    }

    .center li {
      width: 310px;
      text-align: center;
      background: url(../../images/apps/frame_chanpinsheji.png) center center
        no-repeat;
      margin-bottom: 10px;
      height: 197px;
      box-sizing: border-box;
      padding: 10px 15px 0;
    }

    .center li.last {
      width: 100%;
      height: 154px;
      margin-bottom: 0;
      background: url(../../images/apps/frame_jinrongshichang.png);
      background-size: 100% 100%;
    }

    .center .arrow {
      margin: 60px 10px 0;
    }

    .center li .headline_wrap {
      display: inline-block;
      border-bottom: #fff 2px solid;
      margin-bottom: 20px;
      padding: 0 10px;
    }

    .center li .headline {
      height: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .center h6 {
      font-size: 16px;
      color: #fff;
      padding-left: 10px;
      font-weight: bold;
    }

    .center .product {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      align-content: space-between;
    }

    .center .product .layui-btn {
      width: 130px;
      height: 36px;
      line-height: 36px;
      background-color: transparent;
      border-radius: 4px;
      font-size: 14px;
      margin: 0 0 10px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .center .product .layui-btn img {
      margin-right: 10px;
    }

    .center .product .layui-btn-disabled {
      border: none;
      /*background-color: rgba(112,112,112,0.52);*/
      color: #bbb;
      cursor: no-drop !important;
    }

    .center li.last .product {
      width: 100%;
      height: auto;
    }

    .center li.last .product .layui-btn {
      width: auto;
    }

    .center li.last .product .layui-btn:first-child {
      width: 320px;
    }
    .center li.last .product .conter-text {
      text-align: center;
      display: flex;
      width: 320px;
      justify-content: space-between;
    }
    .center li.last .product .conter-text .layui-btn:first-child {
      width: 426px;
      padding-left: 46px;
    }
    .center li.last .product .conter-text .layui-btn:nth-child(2) {
      img {
        width: 28px;
        height: 28px;
      }
    }
    .center li.last .product .layui-btn:nth-child(2) {
      width: 396px;
    }

    .center li.last .product .layui-btn:nth-child(3) {
      width: 256px;
    }

    .center li.arrow_up {
      width: 100%;
    }

    .bottom_part {
      /*border: dashed 2px #1585bc;*/
      padding: 10px 20px;
      box-sizing: border-box;
      margin: 2px;
      background-color: #383f4a;
    }

    .bottom_part .head {
      margin: 0 240px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
    }

    .bottom_part .head .arrow_up {
      display: flex;
      align-items: flex-end;
    }

    .bottom_part .head .arrow_up span {
      color: #fff;
      font-size: 20px;
      display: inline-block;
      margin: 0 18px;
    }

    .bottom_part .head .heading {
      margin: 0;
    }

    .bottom_part .technology {
      display: flex;
      justify-content: space-between;
    }

    .bottom_part .technology li {
      width: 260px;
      background-color: #3f4d64;
      border-radius: 5px;
      padding: 20px 16px 12px;
      /*box-sizing: border-box;*/
      box-sizing: border-box;
    }

    .bottom_part .technology li .headline_wrap {
      display: flex;
      justify-content: center;
    }

    .bottom_part .technology li .headline_wrap .title {
      width: 140px;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 10px;
      border-bottom: #fff 1px solid;
    }

    .bottom_part .technology li .title h6 {
      color: #fff;
      font-size: 16px;
      margin-left: 10px;
    }

    .bottom_part .technology li .technology_item {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }

    .bottom_part .technology li .technology_item .layui-btn {
      width: 108px;
      height: 32px;
      background-color: transparent;
      /*border-radius: 4px;*/
      margin-bottom: 10px;
      font-size: 12px;
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .layui-btn + .layui-btn {
      margin-left: 0;
    }

    .bottom_part .technology li .technology_item .layui-btn img {
      margin-right: 10px;
      width: 16px;
      height: 16px;
    }

    .bottom_part .technology li .technology_item .layui-btn-disabled {
      background-color: transparent;
      color: #bbb;
      border: none;
      cursor: no-drop !important;
    }

    .bottom_part .technology li .technology_item .one_line {
      width: 100% !important;
    }

    .bottom_part .technology li:first-child .technology_item {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }

    .bottom_part .technology li:first-child .technology_item .layui-btn {
      width: 110px;
      height: 32px;
    }
    .bottom_part .technology li:first-child .technology_item .layui-btn img {
      width: 16px;
      height: 16px;
    }
  }
}
.is-backColor {
  background-color: #ffffff !important;
  padding-bottom: 35px;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/myApps/MyAppsCenter.vue